import {
    type SubEventUploadTokenRequestType,
    type UploadTokenResponseType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForSubEventPhoto = async (params: SubEventUploadTokenRequestType): Promise<UploadTokenResponseType> => {
    return await request<UploadTokenResponseType>("/events/getUploadTokenForSubEventPhoto", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForSubEventPhoto;
